/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Numbers({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.95 6.9H.8a.6.6 0 0 0 0 1.2h3.5a.6.6 0 0 0 0-1.2H3.15V1h-1.2v.75a.4.4 0 0 1-.4.4H.8a.6.6 0 0 0 0 1.2h.75c.138 0 .272-.018.4-.05v3.6ZM5.4 5.25a2.35 2.35 0 0 1 4.7 0v.422a2.6 2.6 0 0 1-.761 1.838L7.449 9.4H9.5a.6.6 0 1 1 0 1.2H6a.6.6 0 0 1-.424-1.024L8.49 6.662a1.4 1.4 0 0 0 .41-.99V5.25a1.15 1.15 0 1 0-2.3 0v.25a.6.6 0 1 1-1.2 0v-.25Zm5.7 3.25a.6.6 0 0 1 .6-.6h3.5a.6.6 0 0 1 .424 1.024L14.11 10.44A2.1 2.1 0 0 1 15.8 12.5v.75a2.35 2.35 0 1 1-4.7 0V13a.6.6 0 0 1 1.2 0v.25a1.15 1.15 0 0 0 2.3 0v-.75a.9.9 0 0 0-.9-.9h-1a.6.6 0 0 1-.424-1.024L13.752 9.1H11.7a.6.6 0 0 1-.6-.6Z" clipRule="evenodd" /></svg>;
}
;